import { render, staticRenderFns } from "./appraisalQuestionBankList.vue?vue&type=template&id=d05c86d2"
import script from "./appraisalQuestionBankList.vue?vue&type=script&lang=js"
export * from "./appraisalQuestionBankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports